import type { MatchNode } from "@/lib/api";

export function getMatchById(
  nodes: MatchNode[],
  id: string | null,
): MatchNode | undefined {
  if (!id) return undefined;
  return nodes.find((n) => n.id === id);
}

export function tournamentChampionSteamId(nodes: MatchNode[]): string | null {
  if (nodes.length === 0) return null;
  const maxR = Math.max(...nodes.map((n) => n.round));
  const root = nodes.find((n) => n.round === maxR && n.index === 0);
  return root?.winner ?? null;
}
